import { Button } from 'base/src/components/Button';
import * as S from './style';

import { Options, OptionsHandle } from 'base/src/components/Options';
import { Either } from '../../../../utils/propsUtil';
import { FilterObjectExtended, IApplyedFilter } from '../..';
import React, { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';

import 'react-calendar/dist/Calendar.css';
import { Value } from 'react-calendar/dist/esm/shared/types.js';
import { IsArrayOfType } from 'domain/utils/ReactUtils';
import { Label } from '../../../Basic/Label/label';
import TimePicker from '../../../TimePicker';
interface Props0 {
    title: string
    description: string
    filters: FilterObjectExtended[]
    setBadge: Dispatch<SetStateAction<boolean>>
    applyedFilters: IApplyedFilter[]
    setApplyedFilters: React.Dispatch<React.SetStateAction<IApplyedFilter[]>>
    setClose: Dispatch<SetStateAction<boolean>>
}

interface Props1 {

}

interface Props2 {
}

export type FilterOptionsProps = Props0 & Either<Props1, Props2>;

export function FilterOptions(props: FilterOptionsProps) {

    //Salva as alterações em tempo real e ao clicar em aplicar ele executa as actions salvas

    const optionsRef = [useRef<OptionsHandle>(null)];
    const [currentApplyed, setcurrentApplyed] = useState<IApplyedFilter[]>([])
    const [last, setLast] = useState<FilterObjectExtended>()

    function handleApply(value: string | string[] | Date[], filter: FilterObjectExtended) {
        let a: IApplyedFilter[] | undefined = undefined;

        props.setApplyedFilters(prevFilters => {
            const filterIndex = prevFilters.findIndex(item => item.filter.id === filter.id);
            filter.values = value
            const shouldRemove = (typeof value === "string" && value === "") ||
                (Array.isArray(value) && value.length === 0);

            if (shouldRemove) {
                a = prevFilters.filter(item => item.filter.id !== filter.id);

                return a
            } else if (filterIndex !== -1) {
                const updatedFilters = [...prevFilters];
                updatedFilters[filterIndex] = { filter, action: (v) => { execute(v ? value : null, filter.onChange) } };
                return updatedFilters;
            } else {
                return [...prevFilters, { filter, action: (v) => { execute(v ? value : null, filter.onChange) } }];
            }
        });

        if (a != undefined) {
            setLast(filter)
        }
    }

    /* eslint-disable no-unused-vars */
    function execute(value: string | string[] | Date[] | null, action: ((value: string | undefined) => void) | ((value: string[] | undefined) => void) | ((value: Date[] | undefined) => void) | Dispatch<SetStateAction<string | undefined>> | undefined) {
        if (action == null) { return }
        if (typeof value === "string" && typeof action === "function") {
            (action as (value: string) => void)(value);
            return
        } else if (Array.isArray(value) && typeof action === "function") {
            if (value.every(item => item instanceof Date)) {
                // Se for um array de Date
                (action as (value: Date[]) => void)(value);
            } else {
                // Caso contrário, trata como um array de string
                (action as (value: string[]) => void)(value);
            }
            return;
        }
        (action as (value: undefined) => void)(undefined);

    }

    function run() {

        props.applyedFilters.map((a) => {
            a.action(true)
        })

        setcurrentApplyed(props.applyedFilters)

        if (props.applyedFilters == null || props.applyedFilters.length == 0) { /// ao remover toda a lista, usa o ultimo item para atualizar a ultima vez a api
            last && execute(null, last.onChange)
            setLast(undefined)
        }
    }

    function clear() {
        props.applyedFilters.map((a) => {
            a.action(false)
        })
        props.setApplyedFilters([])
        if (optionsRef != null) {
            optionsRef.map(a => {
                a.current && a.current.Reset()
            })
        }
        setcurrentApplyed([])
    }

    useEffect(() => {
        if ((currentApplyed == null || currentApplyed.length == 0)) {
            props.setBadge(false)
        } else {
            props.setBadge(true)
        }
    }, [currentApplyed])


    const [first, setFirst] = useState<boolean>(false)
    useEffect(() => {
        if (props.applyedFilters == null || props.applyedFilters.length == 0) { return }
        if (first == true) { return }
        setFirst(true)
        if (props.filters.some((f) => f.optionsGroup.some((o) => o.options?.some(s => s.default == true)))) {
            run()
        }
    }, [props.applyedFilters])


    function equalFilter() {
        if (props.applyedFilters.length != currentApplyed.length) {
            return false
        }
        const l1 = props.applyedFilters.map(s => s.filter.values).sort()
        const l2 = currentApplyed.map(s => s.filter.values).sort()
        return l1.every(a => l2.some(c => a.toString() === c.toString()))
    }


    function handleRun() {
        run(); props.setClose(false)
    }


    function handleClear() {
        clear(); props.setClose(false)
    }

    return (
        <S.Container>
            <S.ContainerTitle>
                <S.Title>{props.title}</S.Title>
                <S.Subtitle>{props.description}</S.Subtitle>
            </S.ContainerTitle>
            <S.Options>

                {props.filters && props.filters.map((f, i) => {
                    function temp(value: string | string[]) {
                        handleApply(value, f)
                    }

                    function tempCalendar(value: Value) {

                        const date: Date[] = IsArrayOfType(value) ? value as Date[] : [value as Date];
                        handleApply(date, f)
                    }

                    if (f.calendarOptions == undefined) {
                        return (
                            <S.OptionContainer>
                                <Options title={f.name} enableForm={false} ref={optionsRef[i]} multiple={f.multiple} full onChangeValue={temp} placeholder={f.label ? f.label : f.name} label={f.label ? f.label : f.name} optionsGroup={f.optionsGroup} />
                            </S.OptionContainer>
                        )
                    } else {
                        return (
                            <S.OptionContainer>
                                <Label>{f.label}</Label>
                                <TimePicker minDate={f.calendarOptions.startDate} maxDate={f.calendarOptions.endDate} selectRange={f.calendarOptions.interval} onChange={tempCalendar} />
                            </S.OptionContainer>
                        )
                    }
                }
                )}
            </S.Options>
            <S.ActionContainer>
                <Button iconName='mdi:filter' size='md' disabled={(props.applyedFilters.length == 0 && currentApplyed.length == 0) && (props.applyedFilters == null || props.applyedFilters.length == 0) || equalFilter()} onClick={handleRun} full>Aplicar</Button>
                <Button iconName='mdi:trash' size='md' full disabled={props.applyedFilters == null || props.applyedFilters.length == 0} onClick={handleClear} variant='tertiary'>Limpar</Button>
            </S.ActionContainer>
        </S.Container>
    );
}

export default FilterOptions;